import { useVisitedOffersContext } from '@cian/frontend-visited-offers-widget';
import { IconFunctionalSuccess12, Label } from '@cian/ui-kit';

import { type FC } from 'react';

import { useCardOfferContext } from '@/microfrontends/listing/shared/context/selectors/cardData';

import { TopLabelsBox } from './internal/components/TopLabelsBox';

export const TopLabelsContainer: FC = () => {
  const { id } = useCardOfferContext();

  const { isOfferVisited } = useVisitedOffersContext();

  if (!isOfferVisited(id)) {
    return null;
  }

  return (
    <TopLabelsBox>
      <Label background="black_60" color="white" icon={<IconFunctionalSuccess12 color="white_100" />}>
        Вы смотрели
      </Label>
    </TopLabelsBox>
  );
};
